import { apolloClient } from '~/apollo'
import { DashboardServiceQueryDocument } from '~/gql'

export const fetchShipments = (search = '') => {
  let searchTerm = null

  if (search.length > 0) {
    searchTerm = search
  }

  return apolloClient
    .query({
      query: DashboardServiceQueryDocument,
      variables: {
        searchTerm,
      },
    })
    .then((result) => result.data)
}
